import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import { getRequestedWidgetSize } from 'shared/selectors/app-settings';

import { updateAppSettings } from 'widget/redux/client/actions/app-settings';


@connect(state => ({
  // lazyVideoLists is needed to trigger height calculations
  // TODO: move resizing logic to view
  lazyVideoLists: state.lazyVideoLists,
  requestedWidgetSize: getRequestedWidgetSize(state),
}), {
  updateAppSettings,
})
export default class UpdateWidgetSize extends React.Component {

  static propTypes = {
    requestedWidgetSize: React.PropTypes.object,
    lazyVideoLists: React.PropTypes.object,
    disabled: React.PropTypes.bool,
    updateAppSettings: React.PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
  };

  componentDidMount() {
    this.updateWidgetSize();
    window.addEventListener('resize', this.updateWidgetSize);
  }

  shouldComponentUpdate(nextProps) {
    return !_.isEqual(this.props.lazyVideoLists, nextProps.lazyVideoLists);
  }

  componentDidUpdate() {
    this.updateWidgetSize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidgetSize);
  }

  @autobind
  @debounce
  updateWidgetSize() {
    if (this.props.disabled) {
      return;
    }

    const { requestedWidgetSize, updateAppSettings } = this.props;
    const widgetSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    if (!widgetSize.width || _.isEqual(requestedWidgetSize, widgetSize)) {
      return;
    }

    // TODO: move to separate action
    updateAppSettings({
      requestedWidgetSize: widgetSize,
    });
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/data-components/update-widget-size.js